import { ActionIcon, Group, keys, Select, TextInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconSearch } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import TextFilter from "./TextFilter/TextFilter";
import { useFilterReset } from "./FilterResetContext";
import { RowData } from "../../../types/types";

export default function FilterGroup({
  type,
  labels,
  setLoading,
  setSortedData,
  handleSearchChange,
  search,
}: {
  type: string;
  labels: string[];
  setLoading(state: boolean): void;
  setSortedData(data: RowData[]): void;
  handleSearchChange(event: React.ChangeEvent<HTMLInputElement>): void;
  search: string;
}) {
  // const [range, setRange] = useState<[Date | null, Date | null]>([null, null]);
  const { resetKey } = useFilterReset();
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [searchTerm0, setSearchTerm0] = useState("");
  const [searchTerm1, setSearchTerm1] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");

  // clear text if navbar item clicked using context
  useEffect(() => {
    setDateRange([null, null]);
    setStatusFilter(null);
  }, [resetKey]);

  function formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  function setParams(): string {
    let paramsObj = {} as { [key: string]: any };

    if (dateRange[0] !== null || dateRange[1] !== null) {
      // format dates if entered
      const fromDate = formatDate(dateRange[0]!);
      const toDate = formatDate(dateRange[1]!);
      paramsObj["dateFrom"] = fromDate;
      paramsObj["dateTo"] = toDate;
    }

    if (type === "invs") {
      if (searchTerm0) {
        paramsObj["invoiceNumber"] = searchTerm0;
      }
      if (statusFilter) {
        paramsObj["status"] = statusFilter.toLowerCase();
      }
    } else if (type === "card") {
      // mandate or card
      if (searchTerm0) {
        paramsObj["cardNumber"] = searchTerm0;
      }
      if (searchTerm1) {
        paramsObj["type"] = searchTerm1;
      }
    } else if (type === "mandts") {
      if (searchTerm0) {
        paramsObj["mandate_name"] = searchTerm0;
      }
      if (searchTerm1) {
        paramsObj["state"] = searchTerm1;
      }
      if (searchTerm2) {
        paramsObj["reference"] = searchTerm2;
      }
      if (searchTerm3) {
        paramsObj["recurring_amount"] = searchTerm3;
      }
    }

    let params = Object.entries(paramsObj)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return params;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const params = setParams();
      console.log("params: " + params);
      // POST to API
      const response = await fetch(
        window.location.origin + "/server/client_service/mandates?" + params
      );
      const resData = await response.json();
      console.log("filtered data: ", resData);
      setSortedData(resData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Group wrap="nowrap">
        {type === "cards" ? (
          <>
            <TextInput
              placeholder="Search by any field"
              mb="md"
              w="100%"
              leftSection={<IconSearch size={16} stroke={1.5} />}
              value={search}
              onChange={handleSearchChange}
            />
          </>
        ) : type === "invs" ? (
          <>
            <TextFilter
              label={labels[0]}
              value={searchTerm0}
              onChange={setSearchTerm0}
            />
            <Select
              label="Status"
              placeholder="Select status"
              data={["Paid", "Sent", "Overdue"]}
              value={statusFilter}
              onChange={setStatusFilter}
              clearable
              w="15%"
              mb="md"
            />
            <DatePickerInput
              type="range"
              label="Date Range"
              placeholder="Pick date range"
              allowSingleDateInRange
              value={dateRange}
              onChange={setDateRange}
              mb="md"
              w="25%"
            />
          </>
        ) : type === "mandts" ? (
          <>
            <TextFilter
              label={labels[0]}
              value={searchTerm0}
              onChange={setSearchTerm0}
            />
            <TextFilter
              label={labels[1]}
              value={searchTerm1}
              onChange={setSearchTerm1}
            />
            <TextFilter
              label={labels[2]}
              value={searchTerm2}
              onChange={setSearchTerm2}
            />
            <TextFilter
              label={labels[3]}
              value={searchTerm3}
              onChange={setSearchTerm3}
            />
          </>
        ) : null}
        {type !== "cards" ? (
          <ActionIcon
            variant="transparent"
            radius="md"
            mt="sm"
            size="md"
            type="submit"
          >
            <IconSearch size={20} />
          </ActionIcon>
        ) : null}
      </Group>
    </form>
  );
}
